import { createFileRoute, useSearch } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { DebtForm } from '@/pages/debts/form';
import { PROTECTED, ADMINISTRATION } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${ADMINISTRATION}`;

export const Route = createFileRoute(
  '/protected/_layout/administration/_layout/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditAdministrationModal,
});

function EditAdministrationModal() {
  const { id } = Route.useParams();
  const search = useSearch({ strict: false }) as { subTab?: string };
  const subTab = search.subTab ?? 'payroll';
  if (subTab === 'debts') {
    return <DebtForm id={id} returnUrl={RETURN_URL} />;
  }
  return <DocumentForm id={id} subTab={subTab} returnUrl={RETURN_URL} />;
}
